import * as React from "react";
import styled from "../../styled-components";
import { media } from "../../breakpoints";

const Footer = styled.footer`
  background-color: transparent;
  color: ${props => props.theme.colors.white};
  padding: 30px 100px;

  ${media.TABLET`
    padding: 20px;
  `};
`;

const FooterContainer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${media.TABLET`
    flex-direction: column;
  `};
`;

const Copyright = styled.span`
  font-size: 12px;
  margin: 20px 10px 0 0;

  ${media.TABLET`
    margin-bottom: 20px;
    text-align: center;
    width: 100%;
  `};
`;

export interface IAppFooterProps {
  hideVoterInfo?: boolean;
}

const AppFooter: React.SFC<IAppFooterProps> = props => {
  return (
    <Footer>
      <FooterContainer>
        <Copyright>
          &copy; Say | Developed by Say Technologies LLC, a subsidiary of
          A Say Inc.
          {props.hideVoterInfo
            ? ""
            : ` | You must be a verified TSLA shareholder to participate.
          Please note that this site is a way to share your views and is not a
          voter instruction form or means of casting a proxy vote.`}
        </Copyright>
      </FooterContainer>
    </Footer>
  );
};

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppLayout/AppFooter.tsx